import { IBrand, IPagination } from "@shared/lib/types";
import { IBrief } from "@shared/lib/types/brief";
import { IBriefLedger, LEDGER_TYPE } from "@shared/lib/types/briefLedger";
import { IPaymentHistory } from "@shared/lib/types/briefPayment";

export interface IPurchases {
  data: IGetPurchase[];
  pagination: IPagination;
}

export interface IGetPurchase extends IBriefLedger {
  _id: string;
  brand: IBrand;
  brandId: string;
  billing: {
    _id: string;
    name: string;
    billingId: string;
  };
  billingId: string;
  brief: IBrief;
  briefId: string;
  type: LEDGER_TYPE;
  subType: string;
  remarks: string;
  sellingCost: number;
  serviceCost: number;
  baseCost: number;
  gstRate: number;
  gstAmount: number;
  totalAmount: number;
  createdBy: string;
  createdByModelName: string;
  createdByType: string;
  updatedBy: string;
  updatedByModelName: string;
  updatedByType: string;
  history: {
    createdOn: string;
    name: string;
    remarks: string[];
    userId: string;
    userType: string;
  }[];
  createdAt: string;
  updatedAt: string;
  __v: number;
  brandLedgerId: string;
  isEditable: boolean;
  category: string;
}

export interface ICreditNoteOnInvoice {
  creditedToAccountingId: string;
  baseAmount: number;
  gstAmount: number;
  totalAmount: number;
  brandLedgerIds: string[];
  date: string;
  url: string;
  accountingNumber: string;
  remarks?: string;
}

export interface ICreatePurchase {
  briefId: string;
  remarks: string;
  sellingCost: number;
  serviceCost: number;
  gstRate: number;
  type: LEDGER_TYPE;
  subType: string;
  category: string;
}

export interface ICreatePayment {
  brandId: string;
  amountBreakDown: {
    brandAccountingId: string;
    amount: number;
    tdsAmount?: number;
    isTdsDeducted: boolean;
  }[];
  subType: string;
  method: string;
  description?: string;
  tnxReference: string;
  proofUrl?: string;
}

export interface IPayments {
  data: IPayment[];
  pagination: IPagination;
}

export interface IPayment {
  _id: string;
  brandId: string;
  brandAccountingIds: {
    _id: string;
    accountingNumber: string;
  }[];
  amountBreakdown: {
    brandAccountingId: string;
    amount: number;
    tdsAmount: number;
    isTdsDeducted: boolean;
    tdsPaymentReferenceId: string;
  }[];
  type: LEDGER_TYPE;
  amount: number;
  method: string;
  subType: string;
  description?: string;
  tnxReference: string;
  proofUrl?: string;
  createdBy: string;
  createdByModelName: string;
  createdByType: string;
  updatedBy: string;
  updatedByModelName: string;
  updatedByType: string;
  history: IPaymentHistory;
  createdAt: string;
  updatedAt: string;
  __v: number;
}

export const PAYMENT_QUERY_KEY = ["payments"];
